import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateBillingInfo as UpdateBillingInfoMutation,
    UpdateBillingInfoVariables as UpdateBillingInfoMutationVariables,
    BillingInfoUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_BILLING_INFO from '../mutations/update-billing-info.graphql';

export function useUpdateBillingInfo(): {
    updateBillingInfo: (arg1: BillingInfoUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [billingInfoUpdate, {loading: isLoading, error}] = useMutation<
        UpdateBillingInfoMutation,
        UpdateBillingInfoMutationVariables
    >(UPDATE_BILLING_INFO);

    return {
        updateBillingInfo: (input: BillingInfoUpdateInput) =>
            billingInfoUpdate({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
